import React, { useState, useEffect } from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import useStyles from './useStyle'
import UserTable from './TableNavigable/TableNavigable'
import InfoIcon from '@mui/icons-material/Info'
import BreadcrumbsComponent from './Breadcrumbs/Breadcrumbs'
import { getOrganizationWithID } from '../../../redux/actions/Organizations'
import { useDispatch } from 'react-redux'

export default function Users () {
  const classes = useStyles()
  const [organization, setorganization] = useState(null)
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const { id } = useParams()
  const dispatch = useDispatch()

  // get organization with ID
  const getOrganization = async () => {
    const response = await dispatch(getOrganizationWithID(id))
    if (response) {
      setorganization(response)
    }
  }

  useEffect(async () => {
    setLoading(true)
    await getOrganization()
    setLoading(false)
  }, [id])

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <BreadcrumbsComponent name={organization?.organizationName} />

      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Usuarios asociados a una organización
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          La siguiente lista muestra los usuarios asociados a la organización{' '}
          {organization ? organization.organizationName : ''}
        </Typography>
      </div>
      <div className={classes.boxTable}>
        <UserTable
          id={id}
          rows={rows}
          setRows={setRows}
          setLoading={setLoading}
        />
      </div>
    </div>
  )
}
